const cache = {}

const clearCache = () => {
    for (var domain in cache) {
        delete cache[domain]
    }
}

const parseDomain = (domain) => {
    if (!(domain in cache)) {
        cache[domain] = domain.split(".").reverse()
    }
    return cache[domain]
}

const compareDomains = (a, b) => {
    a = parseDomain(a)
    b = parseDomain(b)
    var i
    for (i = 0; i < a.length && i < b.length; i++) {
        var r = a[i].localeCompare(b[i])
        if (r != 0) {
            return r
        }
    }
    if (i < a.length) {
        return 1
    } else if (i < b.length) {
        return -1 
    }
    return 0
}

export default (domains) => {
    domains.sort(compareDomains)
    clearCache()
    
}
